import { SelectionAny, SelectionLatitude, SelectionLongitude } from './internal';
export class SelectionCoordinates extends SelectionAny {
    getLatitude() {
        return this.get("LATI" /* Tag.Latitude */, null, SelectionLatitude);
    }
    getLongitude() {
        return this.get("LONG" /* Tag.Longitude */, null, SelectionLongitude);
    }
}
//# sourceMappingURL=SelectionCoordinates.js.map